import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import { createLeadFinance } from '../../requests/lead_finance_request';
import { createLeadProfileLeadFinanceSuccess, createLeadProfileLeadFinanceFailure } from '../actions/lead_profile_lead_finance.actions';
import { CREATE_LEAD_PROFILE_LEAD_FINANCE } from '../constants/lead_profile_lead_finance.constants';

function* createLeadProfileLeadFinanceRequest({ params }) {
    const { result, error, options } = yield call(createLeadFinance, params);
    if (result) {
        yield put(createLeadProfileLeadFinanceSuccess(options));
        message.success('Finance info was saved successfully');
    } else {
        yield put(createLeadProfileLeadFinanceFailure(error));
        message.error(error.message || error.msg || error.errormsg || 'Error with request, please contact admin');
    }
}

export default function* createLeadProfileLeadFinanceSaga() {
    yield takeEvery(CREATE_LEAD_PROFILE_LEAD_FINANCE, createLeadProfileLeadFinanceRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/create_lead_profile_lead_finance.saga.js